//use in AuthManager.ts to ensure that the same instance of axios is being accessed in both typescript and javascript
import axios from "axios"

export default axios